import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatCheckboxChange, MatDialogRef, MatRadioChange } from '@angular/material';
import { EditContactComponent } from '../edit-contact/edit-contact.component';
import { hasTag} from '../../util/tag-utils';
import { Business } from '../models/business.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { FlyingClub } from '../models/flying-club.model';

@Component({
  selector: 'app-edit-club-details',
  templateUrl: './edit-club-details.component.html',
  styleUrls: ['./edit-club-details.component.scss']
})

export class EditClubDetailsComponent implements OnInit {

  formGroup: FormGroup;
  business: Business;
  isForProfit: boolean;
  isAvailable: boolean;
  hasWaitingList: boolean;
  isLoading = false;
  memberSizePlaceHolder = 'Average Membership Size';
  _equityClubTag = 'Flying Club::Equity Club';
  _membershipAvailTag = 'Flying Club::Membership::Open';
  _membershipWaitingListTag = 'Flying Club::Membership::Waiting List';
  _originalClubData: FlyingClub;
  constructor(private _matDialogRef: MatDialogRef<EditContactComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _businessManagerService: BusinessManagerService,
              private _tagService: TagService) {
   this.business = data.business;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close(null);
    });
    this._originalClubData = Object.assign(new FlyingClub(), this.business.flyingClub);
    this.formGroup = new FormGroup({
      orgType: new FormControl(''),
      aveNumMembers: new FormControl(''),
      numOfAC: new FormControl(''),
      membershipsAvail: new FormControl('')
    });
    this.isForProfit = hasTag(this.business.tags, this._equityClubTag);
    this.isAvailable = hasTag(this.business.tags, this._membershipAvailTag);
    this.hasWaitingList = hasTag(this.business.tags, this._membershipWaitingListTag);
  }

  forProfitChanged(radioChange: MatRadioChange) {
    if (radioChange.source.value === '1' && !this.isForProfit) {
      this.isForProfit = true;
    } else if (radioChange.source.value === '2' && this.isForProfit) {
      this.isForProfit = false;
    }
  }

  membershipChanged(radioChange: MatRadioChange) {
    if (radioChange.source.value === '1' && !this.isAvailable) {
      this.isAvailable = true;
      this.hasWaitingList = false;
    } else if (radioChange.source.value === '2' && this.isAvailable) {
      this.isAvailable = false;
    }
  }

  waitingListChecked(checkbox: MatCheckboxChange) {
    if (checkbox.checked) {
      this.hasWaitingList = true;
    } else {
      this.hasWaitingList = false;
    }
  }

  aveMemberUnfocussed() {
    const MEMBERS = this.business.flyingClub.clubMembers;
    this.business.flyingClub.clubMembers =  (!MEMBERS || MEMBERS < 0) ? 0 : Math.floor(MEMBERS);
  }

  numOfACUnfocussed() {
    const AIRCRAFT = this.business.flyingClub.clubAircraft;
    this.business.flyingClub.clubAircraft =  (!AIRCRAFT || AIRCRAFT < 0) ? 0 : Math.floor(AIRCRAFT);
  }

  close(success: boolean) {
    if (success === null) {
      Object.assign(this.business.flyingClub, this._originalClubData);
    }
    this._matDialogRef.close(success);
  }

  async save () {
    this.isLoading = true;
    try {
      const EQUITY_TAG_ID = 42873;
      const MEMBER_AVAIL_TAG_ID = 42842;
      const MEMBER_WAITING_LIST_TAG_ID = 49285;
      if (this.isForProfit && !hasTag(this.business.tags, this._equityClubTag)) {
        await this._tagService.postTag(EQUITY_TAG_ID, this.business.id);
      } else if (!this.isForProfit && hasTag(this.business.tags, this._equityClubTag)) {
        await this._tagService.deleteTag(EQUITY_TAG_ID, this.business.id);
      }
      if (this.isAvailable && !hasTag(this.business.tags, this._membershipAvailTag)) {
        await this._tagService.postTag(MEMBER_AVAIL_TAG_ID, this.business.id);
      } else if (!this.isAvailable && hasTag(this.business.tags, this._membershipAvailTag)) {
        await this._tagService.deleteTag(MEMBER_AVAIL_TAG_ID, this.business.id);
      }
      if (this.hasWaitingList && !hasTag(this.business.tags, this._membershipWaitingListTag)) {
        await this._tagService.postTag(MEMBER_WAITING_LIST_TAG_ID, this.business.id);
      } else if (!this.hasWaitingList && hasTag(this.business.tags, this._membershipWaitingListTag)) {
        await this._tagService.deleteTag(MEMBER_WAITING_LIST_TAG_ID, this.business.id);
      }
      const newBusiness = await this._businessManagerService.updateBusiness(this.business);
      Object.assign(this.business, newBusiness);
    } catch (e) {
      this.close(false);
      this.isLoading = false;
      return;
    }
    this.isLoading = false;
    this.close(true);
  }
}
